module.exports = __webpack_public_path__ + "static/media/md-trending-down.65426337.svg";